import React from 'react';
import './ProfileName.css';

const ProfileName = ({name}) => {
    return (
        <div className={"ProfileName"}>
            {name}
        </div>
    );
};

export default ProfileName;